
export interface IExternalReplication {
    disabled?: boolean;
    taskId?: number;
    name?: string;
    mentorNode?: string;
    delayReplicationFor?: string;
}